import {
  ResponsiveContainer,
  AreaChart,
  Area,
  XAxis,
  YAxis,
  Tooltip,
  BarChart,
  Bar,
  LineChart,
  Line,
  CartesianGrid,
} from "recharts";

export default function AnimatedChart({
  type = "revenue",
  charts = {},
}) {
  // Revenue / Orders / GST
  if (["revenue", "orders", "gst"].includes(type)) {
    const data = charts[type] || [];

    return (
      <div className="h-72">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={data}>
            <defs>
              <linearGradient id="goldGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#facc15" stopOpacity={0.6} />
                <stop offset="100%" stopColor="#facc15" stopOpacity={0} />
              </linearGradient>
            </defs>

            <XAxis dataKey="date" stroke="#6b7280" />
            <YAxis stroke="#6b7280" />

            <Tooltip
              contentStyle={{
                background: "#0b0b0f",
                border: "1px solid rgba(255,255,255,.1)",
                borderRadius: "12px",
              }}
            />

            <Area
              type="monotone"
              dataKey="value"
              stroke="#facc15"
              strokeWidth={2}
              fill="url(#goldGradient)"
              animationDuration={900}
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    );
  }

  // Top Selling Items
  if (type === "top-items") {
    return (
      <div className="h-72">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={charts.topItems || []}>
            <CartesianGrid strokeDasharray="3 3" stroke="#1f2937" />
            <XAxis dataKey="item" stroke="#9ca3af" />
            <YAxis stroke="#9ca3af" />
            <Tooltip />

            <Bar
              dataKey="qty"
              fill="#facc15"
              radius={[8, 8, 0, 0]}
              animationDuration={800}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    );
  }

  // Production vs Sales
  if (type === "production-vs-sales") {
    return (
      <div className="h-72">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={charts.productionVsSales || []}>
            <CartesianGrid strokeDasharray="3 3" stroke="#1f2937" />
            <XAxis dataKey="date" stroke="#9ca3af" />
            <YAxis stroke="#9ca3af" />
            <Tooltip />

            <Line
              type="monotone"
              dataKey="production"
              stroke="#facc15"
              strokeWidth={2}
              dot={false}
            />

            <Line
              type="monotone"
              dataKey="sales"
              stroke="#22c55e"
              strokeWidth={2}
              dot={false}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    );
  }

  return null;
}